import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PrivateCampaignRoutingModule } from "./private-campaign-routing.module";
import { CreateComponent } from './create/create.component';

import { CrudModule } from '../../helpers/crud/crud.module';

import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { TranslateModule } from '@ngx-translate/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatInputModule } from '@angular/material/input';

import { EnumToArrayPipe } from './enum-to-array.pipe';
import { UserAuthService } from '../../services/user/user-auth.service';
import { SpotService } from '../spots/services/spot.service';
import { MatCardModule } from '@angular/material/card';
import { DiffusionDaysService } from './services/diffusionDays.service';
import { CampaignService } from './services/campaign.service';
import { ScreenLocationService } from './services/screenLocation.service';
import { FaceFilterParams, FaceService, FilteredFaceDetailsParams } from './services/face.service';
import { ChooseScreensComponent } from './choose-screen/choose-screen.component';
import { NavigationModule } from '../../helpers/navigation/navigation.module';
import { PipesModule } from "../../helpers/pipes/pipes.module";
import { FilterModule } from '../filter/filter.module';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { WncmScreenFilterComponent } from '../../helpers/others/wncm-screen-filter/wncm-screen-filter.component';
import { MatRippleModule } from '@angular/material/core';




@NgModule({
    declarations: [ChooseScreensComponent, EnumToArrayPipe, CreateComponent],
    imports: [
        CommonModule,
        CrudModule,
        MatCardModule,
        MatSlideToggleModule,
        PrivateCampaignRoutingModule,
        TranslateModule,
        MatExpansionModule,
        NgxMaterialTimepickerModule,
        MatButtonToggleModule,
        MatInputModule,
        NavigationModule,
        PipesModule,
        FilterModule,
        InfiniteScrollModule,
        WncmScreenFilterComponent,
        MatRippleModule,
    ],
    providers: [
        DiffusionDaysService,
        // ParamWeatherService,
        CampaignService,
        FaceFilterParams,
        FaceService,
        SpotService,
        ScreenLocationService,
        FilteredFaceDetailsParams
    ],
    exports: [EnumToArrayPipe]
})
export class PrivateCampaignModule { }
